<script>
// `~/stores/comment-store` and `%/apps/conversations/stores/conversation-store`
// live outside the editor directory tree. Canvas preview just renders
// the button.
import { mapState } from "pinia";
import { useConfigurationStore } from "%/dynamic-component-editor/stores/configuration-store";
import {
  CommentsWidgetElementMixin,
} from "%/dynamic-component-editor/standard-elements/comments-widget/comments-widget-element-mixin";
import BaseButtonElement
  from "%/dynamic-component-editor/standard-elements/button-element/BaseButtonElement.vue";
import ButtonOptions from "%/dynamic-component-editor/bundles/button-options";

export default {
  name: "SubmitCommentButton",
  extends: BaseButtonElement,
  mixins: [CommentsWidgetElementMixin],
  elementPanelSettings: {
    displayName: "Submit Comment",
    displayIcon: "button",
    elementGroup: "commentWidgetElements",
    elementType: "element",
  },
  optionBundles: [
    new ButtonOptions({
      "default.text-option": "Comment",
      "default.icon": "",
    }, {
      "button-action": true,
      "link-type": true,
      "href-option": true,
    }),
  ],
  computed: {
    ...mapState(useConfigurationStore, ["canCommentOnPosts"]),
    shouldRenderButton() {
      return this.editMode || this.canCommentOnPosts;
    },
  },
  methods: {
    handleButtonClick() {
      // No-op in Studio canvas preview.
      if (this.showsSampleComments) {
        return;
      }
      this.storyComments.submitComposer(this.storyEntityId);
    },
  },
};
</script>
